export default "__VITE_ASSET__CsP0lsuJ__"